module.exports = __webpack_public_path__ + "static/media/8772.bcc6ed70.png";